import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Sol-Ark.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Sol-Ark Inverters" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/Sol-Ark.js